<div class="row">
  <div class="col-6 input-data">
    <div class="input-data">
      <label for="Queue">{{QueueName}}<span [ngClass]="isErrorMsgRequired ? 'star' : ''" *ngIf="field.isRequired"> *</span></label>
      <select
        [ngModel]="selectedQueue"
        name="Queue"
        id="Queue"
        (change)="onDropdownChange($event)"
        [disabled]="field.isDisabled"
       >
        <option value="-1">Select One</option>
        <option
          *ngFor="let option of queueOptions | orderBy: 'DisplayOrder'"
          value="{{ option.Value }}"
        >
          {{ option.Name }}
        </option>
      </select>
      <!-- <div class="underline-fixed" style="width: 10rem"></div> -->
    </div>
    <div class="text-danger" *ngIf="selectedQueue=='-1'">
      <small *ngIf="selectedQueue=='-1' && isErrorMsgRequired">Queue is required</small>
    </div>
    </div>
    <div class="col-6 input-data">
      <div class="input-data">
        <label for="Agent">{{AgentName}}<span [ngClass]="isErrorMsgRequired ? 'star' : ''" *ngIf="field.isRequired"> *</span></label>
        <select
          [ngModel]="selectedAgent"
          name="Agent"
          id="Agent"
          (change)="onDropdownChange($event)"
          [disabled]="field.isDisabled"
         >
          <option value="-1">Select One</option>
          <option
            *ngFor="let option of agentOptions | orderBy: 'DisplayOrder'"
            value="{{ option.Value }}"
          >
            {{ option.Name }}
          </option>
        </select>
        <!-- <div class="underline-fixed" style="width: 10rem"></div> -->
      </div>
      <div class="text-danger" *ngIf="selectedAgent=='-1'">
        <small *ngIf="selectedAgent=='-1' && isErrorMsgRequired">Agent is required</small>
      </div>
      </div>
</div>
